import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnInit,
  AfterViewInit,
} from "@angular/core";

import { ParentContainerComponent } from "../parent-container/parent-container.component";
@Component({
  selector: "app-widget",
  templateUrl: "./widget.component.html",
  styleUrls: ["./widget.component.scss"],
})
export class WidgetComponent implements OnInit {
  @ViewChild("component", { read: ViewContainerRef, static: false })
  component: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngAfterViewInit() {
    if (this.component) {
      this.drawBarChart();
    } else {
      console.error('ViewChild "component" is not initialized.');
    }
  }

  ngOnInit(): void {
    
  }

  public drawBarChart(): void {
    let cmpFactory = this.componentFactoryResolver.resolveComponentFactory(
      ParentContainerComponent
    );
    this.component.createComponent(cmpFactory);
  }
}
